export default "__VITE_PUBLIC_ASSET__4969ac21__"